module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/bag-1-32c434efcd9c6ae4862e98e932ad20ce.svg";